import { useTargetMbox } from '@webmotors/anunciar.tools';

import { Chat } from '@page/chat.page';
import type { TChatPageConfig } from '@page/chat.types';

const MBOX_NAME = '';
const MBOX_KEY = 'chat-variant';

const ChatRenderer = (chatProps: TChatPageConfig) => {
	const hasAbTest = MBOX_NAME.length > 0;

	const { variation, isLoading } = useTargetMbox<string>({
		mbox: MBOX_NAME,
		key: MBOX_KEY,
		run: hasAbTest,
	});

	if (hasAbTest && isLoading) return null;

	// TODO: quando v2 existir, renderizar <ChatV2 /> quando variation === 'B'
	if (variation === 'B') return <Chat {...chatProps} />;

	return <Chat {...chatProps} />;
};

ChatRenderer.displayName = 'ChatRenderer';
export { ChatRenderer };
